import {
  ApplicationRef,
  ComponentRef,
  createComponent,
  EmbeddedViewRef,
  EnvironmentInjector,
  EventEmitter,
  Inject,
  Injectable,
  Type,
} from '@angular/core';
import {DOCUMENT} from '@angular/common';

export class ModalOptions {
  data?: {}
  onClose: (data: any) => void
}

@Injectable({
  providedIn: 'root',
})
export class ModalService<T> {
  private componentRef: ComponentRef<T> | undefined;
  public onClose = new EventEmitter<any>();

  constructor(
    private environmentInjector: EnvironmentInjector,
    private appRef: ApplicationRef,
    @Inject(DOCUMENT)
    private document: Document
  ) {}

  open(component: Type<T>, options = new ModalOptions()) {
    this.onClose.subscribe(options.onClose)
    if (!this.componentRef) {
      this.componentRef = createComponent<T>(component, {
        environmentInjector: this.environmentInjector,
      });
      if (options.data) {
        for (const key in Object.keys(options.data)) {
          this.componentRef.setInput(key, options.data[key]);
        }
      }
      this.appRef.attachView(this.componentRef.hostView);

      const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
      this.document.body.appendChild(domElem);
    }
  }

  close() {
    if (this.componentRef) {
      this.appRef.detachView(this.componentRef.hostView);
      this.componentRef.destroy();
      this.componentRef = undefined;
    }
  }
}
